import { FormControl, ValidatorFn } from "@angular/forms";
import { ProviderUtilities } from "../providers/provider-utilities";

export class MaxMinDateValidator {
    
    static checkMaxMinDate(args):ValidatorFn{     
        let options: any = {};
        let control = null;
        for (let i=0; i < arguments.length; i++) {
          const arg = arguments[i];
          if (arg instanceof FormControl)
            control = arg;
          else if (typeof arg === 'object')
            options = arg;
        }    
        if(!control || control.value == "" || control.value == null)
            return null;

        let returnVal:any;

        let date = new Date();
        let day = date.getDate().toString();
        if (day.length < 2)
          day = '0' + day;
        let month = (date.getMonth() + 1).toString();
        if (month.length < 2)
          month = '0' + month;
    
        let minDate = date;
        if (options.minDate)
          minDate = ProviderUtilities.parseDate(options.minDate);
	      let maxDateStr = (date.getFullYear() + 30) + '-12-31'
        let maxDate = ProviderUtilities.parseDate(maxDateStr);

        if (control.value) {
          let originalDate = control.value.substr(0,10).split('-');
          let dateAsDate = ProviderUtilities.parseDate(control.value.substr(0,10));

          if(originalDate.length == 3 && dateAsDate.getDate() != Number(originalDate[2])){
              returnVal={'invalid_date': true};
          }else if(minDate){
              if(minDate > dateAsDate){
                  returnVal={'future_date': true};
              }else if(maxDate){
                if(maxDate < dateAsDate)
                  returnVal={'past_date': true};
              }
            }else if(maxDate){
              if(maxDate < dateAsDate){
                  returnVal={'past_date': true};
              }
            }
        }

        return returnVal;
    }
}


// WEBPACK FOOTER //
// ./src/validators/maxMinDate.ts